export function floatTo16BitPCM(input) {
    let i = input.length;
    let output = new Int16Array(i);
    while (i--) {
        let s = Math.max(-1, Math.min(1, input[i]));
        output[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
    return output;
}

// You can add more utility functions here and export them similarly
